import { render } from "./CuadroUpgrade.vue?vue&type=template&id=54b83f7e"
import script from "./CuadroUpgrade.vue?vue&type=script&lang=js"
export * from "./CuadroUpgrade.vue?vue&type=script&lang=js"

import "./CuadroUpgrade.vue?vue&type=style&index=0&id=54b83f7e&lang=css"
script.render = render

export default script